"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBankByBankCode = void 0;
const __1 = require("..");
/**
 * The getBankByBankCode returns all occupations if match to the target bank code.
 * @param regionCode the regionCode used to search the bank.
 * @returns list of bank or null
 */
const getBankByBankCode = (bankCode) => {
    switch (bankCode) {
        case 'TH':
            return __1.thBank;
        case 'ID':
            return __1.idBank;
        default:
            return null;
    }
};
exports.getBankByBankCode = getBankByBankCode;
